// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3693":"44804ad52a64ab5a","7736":"11a9964a457b7d52"}[chunkId] + ".css";
};